import React from 'react';
import styles from 'root/globals/Defaults.less'
import CustomComponent from 'root/libs/exaforte/react/CustomComponent';
import {View, Text} from 'react-native';
import { ErrorDialogWrapper, WarningDialogWrapper, ContentDialog } from 'root/globals/Dialog';
import { Button } from 'root/globals/Elements';

export default class MessageDialog extends CustomComponent {
    _handleConfirm() {
        this.props.confirmCallback(this.props.confirmCallbackParams);
        this.props.closeCallback();
    }
    
    render() {
        return <ContentDialog wrapper={(this.props.error ? ErrorDialogWrapper : WarningDialogWrapper)} maxWidth={'sm'} title={this.props.title}>
            <Text className={[styles['color-dark-grey'], styles['f-1-7-5'], styles['text-light']]}>{_.nl2br(this.props.content.join("\r\n"))}</Text>
            <View className={['flex-row d-flex justify-content-end mt-4 pt-4', styles['border-color-light-grey'], styles['bt-1']]}>
                {this.props.confirmCallback ? <>
                    <Button secondary={true} onPress={this.props.closeCallback}>Nee, toch maar niet</Button>
                    <Button onPress={this._handleConfirm} className={['ml-2']}>Ja, doe maar</Button>
                </> : <Button onPress={this.props.closeCallback}>Oke</Button>}
            </View>
        </ContentDialog>;
    }
}

MessageDialog.defaultProps = {
    error: false,
};